import { render, staticRenderFns } from "./DriverStatusComponent.vue?vue&type=template&id=1afcf098&scoped=true&"
import script from "./DriverStatusComponent.vue?vue&type=script&lang=js&"
export * from "./DriverStatusComponent.vue?vue&type=script&lang=js&"
import style0 from "./DriverStatusComponent.vue?vue&type=style&index=0&id=1afcf098&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1afcf098",
  null
  
)

export default component.exports